/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:57.788
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listHouseRateInfo,
	listHouseRateInfoInit,
	listHouseRateInfoByAuthorizations,
	deleteHouseRateInfo
} from '@api/lcf/HouseRateInfo';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listHouseRateInfo({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseRateInfo(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseRateInfoByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseRateInfoByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseRateInfoInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseRateInfoInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseRateInfo({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseRateInfo({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
